
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import CollapseItem from '@/components/collapse.vue';
  import {defaultHeader} from "@/utils/config"
  import Dialog from '@/components/dialog.vue';
	import Message from '@/components/message.vue'
	import cutarrow from '@/components/cutarrow.vue'
  import {
    materialGrassShowdetail,
    materialGrassShowpass,
    materialGrassShowreject,
    materialGrassShowcommentlist,
    materialGrassShowcommentdelete,
    materialGrassShowtaglist,
    productfilterBoxList,
    materialGrassShowrelationProductList,
    materialGrassShowedit
  } from "@/api/material"
  @Component({  
    name: '',
    components: {
      PageFooter,
      CollapseItem,
      'rt-dialog':Dialog,
      Message,
      cutarrow
    }
  })

  export default class ProductList extends Vue {
    private arrowlist:any = [
      {value:1,label:'笔记详情'},
      {value:2,label:'评论详情'},
    ]
    private arrowindex = 1
    private defaultHeader = defaultHeader
    private form:any = {}
    private checktype = 1
    private checkshow = false
    private rejectreason = ''
    
    private pageNo = 1;
    private pageSize = 10;
    private total = 0;
    private keywords = ''
    private tablelist:any = []
    private tableloading = false
    private commentmsg:any = {}
    private rowmsg:any = {}
    private delShow = false
    private showSelShop = false
    private shopId = ''
    private shoplist:any = []
    private showSelTag = false
    private tagId = ''
    private shopindex = 1
    private lastkeywords = ''
    private previewlist:any = []


    private mounted () {
      if(Number(this.$route.query.type)==3){
        this.arrowindex = 2
        this.gettablelist()
      }else if(Number(this.$route.query.Id)){
        this.getinfo()
        this.getProductList()
      }
    }

    
    private touchbottom(){
			this.shopindex++
			this.getProductList(this.lastkeywords)
		}
    private getsaveData(){
      let form = JSON.parse(JSON.stringify(this.form))
      console.log(form)
      form = {
        Id:form.Id,
        Title:form.Title,
        MainBody:form.MainBody,
        ProductIds:form.ProductList.map(v=>v.Id),
        TagIds:form.TagList.map(v=>v.Id),
        ThumbImgUrl:form.ThumbImgUrl,
        VideoUrl:form.VideoUrl,
        ImgUrls:form.ImgUrls.map(v=>v.ImgUrl)
      }
      return form
    }
    private async save(){
      try{
        let res:any = await materialGrassShowedit(this.getsaveData())
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.goback()
        }
      }finally{
        //
      }
    }
    private chooseTag(e){
      let tag = this.form.TagAllList.find(v=>v.Id==e)
      if(tag&&tag.Id){
        this.form.TagList.push(tag)
      }
      this.showSelTag = false
      this.tagId = ''
    }
    private pushTag(){
      if(this.showSelTag) return
      this.showSelTag = true
      this.tagId = ''
    }
    private chooseShop(e){
      let shop = this.shoplist.find(v=>v.Id==e)
      if(shop&&shop.Id){
        this.form.ProductList.push(shop)
      }
      // console.log(this.form.ProductList)
      this.showSelShop = false
      this.shopId = ''
    }
    private pushShop(){
      if(this.showSelShop) return
      this.showSelShop = true
      this.shopId = ''
    }
    private clearItem(e,name){
      this.form[name].splice(e,1)
    }
    private async getProductList(keywords?:string) {
			if((keywords&&keywords!=this.lastkeywords)||(this.lastkeywords&&!keywords)){
        this.shopindex = 1
				this.shoplist = []
				this.lastkeywords = keywords
      }
			const params: any = {
				Skip: (this.shopindex-1)*20,
				Take: 20,
				Keywords:keywords
			}
			try {
				const res: any = await materialGrassShowrelationProductList(params)
				if (res.IsSuccess) {
					this.shoplist = [...this.shoplist,...res.Result.Results]
				} 
			} catch (e) {
				console.log('productList ===>', e)
			}
		}
    private changearrow(e){
      if(e==1){
        this.getinfo()
      }else if(e==2){
        this.gettablelist()
      }
    }
    private async confirmdel(){
      try{
        let res = await materialGrassShowcommentdelete({
          Id:this.rowmsg.Id
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.delShow = false
          this.gettablelist()
        }
      }finally{
        //
      }
    }
    private delcomments(row){
      this.rowmsg = row
      this.delShow = true
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private clearSearch(){
      this.keywords = ''
      this.doSearch()
    }
    private changeCurrent(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
          MaterialGrassShowId:this.$route.query.Id,
          Keywords:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        let res=  await materialGrassShowcommentlist(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results.map((v,i)=>{
            v.number = (this.pageNo-1)*this.pageSize + i + 1
            return v
          })
          this.total = res.Result.Total
          this.commentmsg = res.Result
        }
      }finally{
        this.tableloading = false
      }
    }
    private async confirmcheck(){
      if(this.checktype==2&&!this.rejectreason){
        this.$message.error('请输入否决原因')
        this.checkshow = true
        return 
      }
      try{
        let edit = await materialGrassShowedit(this.getsaveData())

        let res:any
        let data:any = {
          Id:this.$route.query.Id
        }
        if(this.checktype==1){
          res = await materialGrassShowpass(data)
        }else if(this.checktype==2){
          data.RejectReason = this.rejectreason 
          res = await materialGrassShowreject(data)
        }
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.goback()
        }
      }finally{
        //
      }
    }
    private check(num){
      this.rejectreason = ''
      this.checktype = num
      this.checkshow = true
    }
    private goback(){
      this.$router.go(-1)
    }
    private async getinfo(){
      try{
        let res = await materialGrassShowdetail({
          Id:this.$route.query.Id
        })
        if(res.IsSuccess){
          this.form = res.Result
          this.previewlist = this.form.ImgUrls.map(v=>{
            return v.ImgUrlComplete
          })
        }
      }finally{
        //
      }
    }
  }
